"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConversationalSearchResults = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _ConversationalSearchResultsView = require("./ConversationalSearchResultsView");
var _MessageDisplay = require("./MessageDisplay");
var _useDisclaimerData = _interopRequireDefault(require("../hooks/useDisclaimerData"));
var _utils = require("../utils");
var _ConversationalSearchVideo = require("./ConversationalSearchVideo");
var _classnames = _interopRequireDefault(require("classnames"));
var _ConversationalSearchComponentLoader = require("./ConversationalSearchComponentLoader");
var _PromptSuggestionCardContainer = require("./PromptSuggestionCardContainer");
/* eslint-disable complexity */

const ConversationalSearchResults = ({
  language = {},
  results,
  currentStep,
  options,
  ctaProps,
  host,
  enableDynamicFontScaling,
  videoUrlsOverrides = {},
  AddToCartButton,
  PriceBlock,
  SpinsBlock,
  spinType = 'default',
  isModal,
  hideResultsHeader,
  userSearchInput,
  promptTitle,
  promptContent,
  showUserPrompt,
  showDomainPrompt = false,
  enableSearchVideo = true,
  topContentText,
  isMobile,
  exactBlockConfigs,
  exactApiResponseData,
  smartExactApiResponseData,
  resultsHeadingTextId,
  setSearchBoxInput,
  welcomePageContent
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const {
    aiTerms,
    universalTerms,
    privacyPolicy
  } = (0, _useDisclaimerData.default)(host);
  const {
    welcomeWebmVideoUrlOverride,
    welcomeMp4VideoUrlOverride,
    loadingWebmVideoUrlOverride,
    loadingMp4VideoUrlOverride
  } = videoUrlsOverrides;
  const {
    welcomeWebmVideoUrl,
    welcomeMp4VideoUrl,
    loadingWebmVideoUrl,
    loadingMp4VideoUrl
  } = (0, _utils.getVideoUrls)();
  const {
    alignContent = 'center',
    welcomeVideo = {
      show: true
    },
    welcomeHeading1 = {
      show: true,
      text: ''
    },
    welcomeHeading2 = {
      show: true,
      text: ''
    },
    welcomeTextPara1 = {
      show: true,
      text: ''
    },
    promptSuggestionList = []
  } = welcomePageContent || {};
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "conversational-search-results",
    "data-cy": "conversational-search-results",
    className: (0, _classnames.default)({
      'conversational-search-results-modal-container': isModal,
      'conversational-search-results-container': !isModal
    })
  }, currentStep === 1 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('conversational-search-top-container', {
      'justify-content-start pl-5': alignContent === 'left'
    }),
    "data-testid": "conversational-search-top-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    "data-testid": "conversational-search-top-image",
    "data-cy": "conversational-search-top-image",
    alt: "Top view of conversational AI search",
    className: "conversational-search-top-image",
    src: _utils.topLogoUrl
  })), welcomeVideo.show && /*#__PURE__*/_react.default.createElement(_ConversationalSearchVideo.ConversationalSearchVideo, {
    webmVideoUrl: welcomeWebmVideoUrlOverride || welcomeWebmVideoUrl,
    mp4VideoUrl: welcomeMp4VideoUrlOverride || welcomeMp4VideoUrl,
    videoTitle: formatMessage({
      id: 'welcomeVideoTitle'
    }),
    className: "conversational-search-welcome-video"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "conversational-search-results-step-1 d-flex flex-column"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('welcome-container', {
      'align-items-start pl-4': alignContent === 'left',
      'text-center': alignContent === 'center'
    }),
    "data-testid": "welcome-container"
  }, welcomeHeading1.show && /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-heading-1 heading-font",
    "data-testid": "welcome-heading-1"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: welcomeHeading1?.text || 'welcomeHeading1'
  })), welcomeHeading2.show && /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-heading-2 heading-font",
    "data-testid": "welcome-heading-2"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: welcomeHeading2?.text || 'welcomeHeading2',
    values: {
      br: /*#__PURE__*/_react.default.createElement("br", null)
    }
  })), welcomeTextPara1.show && /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-text-para-1",
    "data-testid": "welcome-text-para-1"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: welcomeTextPara1?.text || 'welcomeTextPara1',
    values: {
      br: /*#__PURE__*/_react.default.createElement("br", null)
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "conversational-search-results-step-1-footer d-flex flex-column"
  }, promptSuggestionList.length > 0 && /*#__PURE__*/_react.default.createElement(_PromptSuggestionCardContainer.PromptSuggestionCardContainer, {
    promptSuggestionList: promptSuggestionList,
    setSearchBoxInput: setSearchBoxInput
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-text-para-2 text-center",
    "data-testid": "welcome-text-para-2"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "welcomeTextPara2",
    values: {
      aiTerms,
      universalTerms,
      privacyPolicy,
      br: /*#__PURE__*/_react.default.createElement("br", null)
    }
  }))))), currentStep === 2 && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('text-center d-flex flex-column justify-center', {
      'conversational-search-results-step-2': enableSearchVideo,
      'conversational-search-results-step-3 ': !enableSearchVideo
    })
  }, enableSearchVideo ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ConversationalSearchVideo.ConversationalSearchVideo, {
    webmVideoUrl: loadingWebmVideoUrlOverride || loadingWebmVideoUrl,
    mp4VideoUrl: loadingMp4VideoUrlOverride || loadingMp4VideoUrl,
    videoTitle: formatMessage({
      id: 'loadingVideoTitle'
    }),
    className: "conversational-search-loading-video"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "standard-heading heading-font"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "loadingText"
  }))) : /*#__PURE__*/_react.default.createElement(_ConversationalSearchComponentLoader.ConversationalSearchResultsComponentLoader, {
    isModal: isModal
  })), currentStep === 3 && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('conversational-search-results-step-3', {
      'mt-5': spinType !== 'default'
    }),
    "data-cy": "conversational-search-results-step-3"
  }, results && /*#__PURE__*/_react.default.createElement(_ConversationalSearchResultsView.ConversationalSearchResultsView, {
    results: results,
    language: language,
    options: options,
    isModal: isModal,
    ctaProps: ctaProps,
    enableDynamicFontScaling: enableDynamicFontScaling,
    AddToCartButton: AddToCartButton,
    PriceBlock: PriceBlock,
    SpinsBlock: SpinsBlock,
    spinType: spinType,
    hideResultsHeader: hideResultsHeader,
    userSearchInput: userSearchInput,
    promptTitle: promptTitle,
    promptContent: promptContent,
    showDomainPrompt: showDomainPrompt,
    topContentText: topContentText,
    showUserPrompt: showUserPrompt,
    isMobile: isMobile,
    exactBlockConfigs: exactBlockConfigs,
    exactApiResponseData: exactApiResponseData,
    smartExactApiResponseData: smartExactApiResponseData,
    resultsHeadingTextId: resultsHeadingTextId
  })), /*#__PURE__*/_react.default.createElement(_MessageDisplay.MessageDisplay, {
    code: currentStep
  }));
};
exports.ConversationalSearchResults = ConversationalSearchResults;
ConversationalSearchResults.propTypes = {
  language: _propTypes.default.object,
  results: _propTypes.default.object,
  currentStep: _propTypes.default.number,
  ctaProps: _propTypes.default.object,
  host: _propTypes.default.string,
  options: _propTypes.default.object,
  enableDynamicFontScaling: _propTypes.default.bool,
  videoUrlsOverrides: _propTypes.default.shape({
    welcomeWebmVideoUrlOverride: _propTypes.default.string,
    welcomeMp4VideoUrlOverride: _propTypes.default.string,
    loadingWebmVideoUrlOverride: _propTypes.default.string,
    loadingMp4VideoUrlOverride: _propTypes.default.string
  }),
  AddToCartButton: _propTypes.default.func,
  PriceBlock: _propTypes.default.func,
  spinType: _propTypes.default.oneOf(['default', 'tight-modern']),
  SpinsBlock: _propTypes.default.func,
  isModal: _propTypes.default.bool,
  hideResultsHeader: _propTypes.default.bool,
  userSearchInput: _propTypes.default.string,
  promptTitle: _propTypes.default.string,
  promptContent: _propTypes.default.string,
  showDomainPrompt: _propTypes.default.bool,
  enableSearchVideo: _propTypes.default.bool,
  topContentText: _propTypes.default.string,
  showUserPrompt: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  exactBlockConfigs: _propTypes.default.shape({
    ExactMatchBlock: _propTypes.default.func,
    exactBlockMode: _propTypes.default.string
  }),
  exactApiResponseData: _propTypes.default.object,
  smartExactApiResponseData: _propTypes.default.object,
  resultsHeadingTextId: _propTypes.default.string,
  setSearchBoxInput: _propTypes.default.func,
  welcomePageContent: _propTypes.default.shape({
    alignContent: _propTypes.default.string,
    welcomeVideo: _propTypes.default.shape({
      show: _propTypes.default.bool
    }),
    welcomeHeading1: _propTypes.default.shape({
      show: _propTypes.default.bool,
      text: _propTypes.default.string
    }),
    welcomeHeading2: _propTypes.default.shape({
      show: _propTypes.default.bool,
      text: _propTypes.default.string
    }),
    welcomeTextPara1: _propTypes.default.shape({
      show: _propTypes.default.bool,
      text: _propTypes.default.string
    }),
    promptSuggestionList: _propTypes.default.arrayOf(_propTypes.default.string)
  })
};